import { type CommandContribution, type CommandRegistry } from '@patsnap/tahiti-core';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { WireFrameExtractDialogService } from '../wire-frame-extract-dialog-service';
import { WireFrameExtractCommand } from './wire-frame-extract-command';
import { WireFrameExtractSubmissionService } from '../wire-frame-extract-service';

@injectable()
export class WireFrameExtractCommandContribution implements CommandContribution {
    constructor(
        @inject(WireFrameExtractDialogService)
        private readonly _wireFrameExtractDialogService: WireFrameExtractDialogService,
        @inject(WireFrameExtractSubmissionService)
        private readonly _wireFrameExtractSubmissionService: WireFrameExtractSubmissionService,
        @inject(WireFrameExtractCommand)
        private readonly _wireFrameExtractCommand: WireFrameExtractCommand,
    ) {
        this._wireFrameExtractDialogService.onSubmit(this._wireFrameExtractSubmissionService.handleSubmit.bind(this._wireFrameExtractSubmissionService));
    }

    registerCommands(registry: CommandRegistry): void {
        registry.registerCommand({
            id: this._wireFrameExtractCommand.id,
            label: this._wireFrameExtractCommand.label,
        }, this._wireFrameExtractCommand);
    }
}
